const data = {
  body: '<g fill="none"><path d="M20.145 4.5L11.9999 18.9801L3.8548 4.5L20.145 4.5Z" stroke-width="2" stroke-linejoin="round" stroke="currentColor"/></g>',
  width: 24,
  height: 24
}
export default data
